module.exports = __webpack_public_path__ + "img/elantra-hybrid-25.f1d57af8.png";